import React from 'react';
import ConfirmationCard from '../ConfirmationCards';

const ConfirmationAddress: React.FC<{
  addresses: GQL.IAddressConfirmation[];
  selectedId: string | number | null;
  setSelectedId: React.Dispatch<React.SetStateAction<string | number | null>>;
  preferentialIdToSelect?: 'idExterno' | 'codigo';
  allowNewAddress?: boolean;
  onClickAddNewAddress?: () => void;
}> = ({
  addresses,
  selectedId,
  setSelectedId,
  preferentialIdToSelect,
  allowNewAddress,
  onClickAddNewAddress,
}) => {
  return (
    <div>
      {addresses.map((address, index) => (
        <ConfirmationCard
          contentCardTitleText={`${address.logradouro}, ${address.numero}${
            address.complemento && `, ${address.complemento}`
          }, ${address.bairro}`}
          contentCardText={`${address.cidade}, ${address.uf} - ${address.cep}`}
          setOption={setSelectedId}
          id={address.codigo || address.idExterno}
          idToSelect={
            preferentialIdToSelect ? address[preferentialIdToSelect] : null
          }
          selectedId={selectedId!}
          key={index}
        />
      ))}

      {allowNewAddress && (
        <ConfirmationCard
          contentCardTitleText='Adicionar novo endereço'
          id='new'
          selectedId={selectedId!}
          setOption={() => {}}
          hideSelector
          onClickCard={onClickAddNewAddress}
        />
      )}
    </div>
  );
};

export default ConfirmationAddress;
